import dayjs from "dayjs"


export const getterDateTimeStr =  (params) => (params.value && dayjs(params.value).format('YYYY-MM-DD HH:mm:ss.SSS')) || null

export const formatterDateTimeNoYear = (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-"